// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'wrench';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M15.527 9.43a4.922 4.922 0 0 0 .92-5.687l-2.514 2.511a1.063 1.063 0 0 1-1.503 0l-.566-.566a1.064 1.064 0 0 1 0-1.503l2.55-2.55a4.92 4.92 0 0 0-6.8 6.436l-6.264 6.26a1.092 1.092 0 0 0 0 1.546l.773.773a1.094 1.094 0 0 0 1.546 0l6.259-6.259a4.92 4.92 0 0 0 5.599-.962z'
  />
);

export const viewBox = '0 0 18 18';
